const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    // Google reCAPTCHA v2 site key (public). Set REACT_APP_RECAPTCHA_SITE_KEY in .env.
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''
};

export default config;
